module.exports = __webpack_public_path__ + "static/media/Flaechenvorhang_35604.0a0c9989.png";